import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import { CheckpointQueues } from './CheckpointQueues';
import { ErrorMessage } from './ErrorMessage';
import { CheckpointQueuesShimmer } from './CheckpointQueuesShimmer';
import { useAvailableAccessTypes } from './access-type-filter/helpers/useAvailableAccessTypes';
import { Section } from '../../content-sections/ui/components/Section';
import { useStores } from '../../app/root/domain/stores/useStores';
import { IQueueList } from '../domain/models/IQueueList';
import ContentWrap from '../../../ui/components/Layout/ContentWrap';

export const SecurityWaitingTimes = observer(() => {
	const { checkpointQueueListStore: store } = useStores();
	const accessTypes = useAvailableAccessTypes();
	const queueLists = store.checkpointQueueLists.filter((queueList) =>
		accessTypes.includes(queueList.accessType),
	);

	useEffect(() => {
		store.load();

		return () => {
			store.reset();
		};
	}, []);

	return (
		<Section>
			<ContentWrap>
				<Main
					isLoading={store.isLoading || !store.finishedInitialLoad}
					error={store.error}
					queueLists={queueLists}
					refresh={() => store.load()}
				/>
			</ContentWrap>
		</Section>
	);
});

interface IMainProps {
	isLoading?: boolean;
	error?: Error;
	queueLists: IQueueList[];
	refresh: () => void;
}

const Main = ({ isLoading, error, ...props }: IMainProps) => {
	if (error) {
		return <ErrorMessage />;
	}

	if (isLoading) {
		return <CheckpointQueuesShimmer />;
	}

	return <CheckpointQueues {...props} />;
};
